class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchButton = this.querySelector('button[type="submit"]') || this.querySelector('button[aria-label*="buscar" i], button[aria-label*="search" i]');
    this.form = this.querySelector('form');

    if (!this.input || !this.form) return;

    // Inicializar eventos
    this.setupEvents();
    this.toggleResetButton(); // Estado inicial
  }

  setupEvents() {
    // Reset del formulario
    this.form.addEventListener('reset', this.onFormReset.bind(this));

    // Cambio en el input (debounce)
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300)
    );

    // Submit del formulario
    this.form.addEventListener('submit', this.onSubmit.bind(this));

    // Enter en el input
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  toggleResetButton() {
    const hasValue = this.input.value.trim().length > 0;
    if (this.resetButton) {
      this.resetButton.classList.toggle('d-none', !hasValue);
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    // Evita reset si hay un ítem seleccionado en búsqueda predictiva
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  // Detecta si el texto parece una referencia
  isReference(query) {
    const trimmed = query.trim();
    if (!trimmed) return false;

    // Personaliza este patrón según tu formato de referencia
    // Ejemplos válidos: REF123, REF-ABC123, ABC-12345, 123456
    const refPattern = /^(REF[-_]?)?[A-Z0-9]{4,15}$/i;
    return refPattern.test(trimmed);
  }

  onSubmit(event) {
    event.preventDefault();
    const query = this.input.value.trim();

    if (!query) return;

    let url;

    if (this.isReference(query)) {
      // Limpiar prefijo "REF" o "REF-"
      const cleanRef = query.replace(/^(REF[-_]?)/i, '').toUpperCase();
      url = `/search?ref=${encodeURIComponent(cleanRef)}`;
    } else {
      url = `/search?q=${encodeURIComponent(query)}`;
    }

    // Redirigir
    window.location.href = url;
  }
}

// === DEBOUNCE UTILITY ===
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// === REGISTRAR COMPONENTE ===
customElements.define('search-form', SearchForm);